import React, { useState, useContext } from 'react'
import { Button, ButtonColorVariant } from '@gousto-internal/citrus-react'

import PropTypes from 'prop-types'

import { endpoint } from '@library/endpoint'
import routes from 'config/routes'

import { getCurrentUserId } from 'routes/Account/Subscription/context/selectors/currentUser'
import { Section } from '../../../components/Section'
import { resubscribeSection } from '../../../subscriptionsSectionsContent'
import { useFetch } from '../../../../../../hooks/useFetch'
import { SubscriptionContext } from '../../../context'
import { actionTypes } from '../../../context/reducers'

const getResult = (loading, response, error) => {
  if (!error && !loading && response && response.status && response.status.toLowerCase() === 'ok') {
    return response.data
  } else {
    return null
  }
}

export const LegacyResubscribe = ({ accessToken }) => {
  const { dispatch, state = {}} = useContext(SubscriptionContext)

  const [shouldResubscribe, setShouldResubscribe] = useState(false)
  const reactivateSubscription = () => {
    setShouldResubscribe(true)
  }

  const userId = getCurrentUserId(state)

  const reactivateSubscriptionUrl = `${endpoint('subscriptioncommand')}/subscriptions/${userId}${routes.subscriptionCommand.activate}`
  const method = 'POST'

  const [loading, response, error] = useFetch({
    url: reactivateSubscriptionUrl,
    needsAuthorization: true,
    accessToken,
    trigger: {
      shouldRequest: shouldResubscribe,
      setShouldRequest: setShouldResubscribe,
    },
    options: {
      method,
    },
  })

  const data = getResult(loading, response, error)

  if (data) {
    setTimeout(() => {
      dispatch({
        type: actionTypes.SUBSCRIPTION_STATUS_UPDATE_RECEIVED,
        data
      })
    }, 0)
  }

  return (
    <Section
      title={resubscribeSection.title}
      subTitle={resubscribeSection.subTitle}
      testingSelector={resubscribeSection.testingSelector}
    >
      <Button
        data-testid="resubscribe-cta"
        onClick={reactivateSubscription}
        colorVariant={ButtonColorVariant.Primary}
        width="100%"
      >
        Reactivate subscription
      </Button>
    </Section>
  )
}

LegacyResubscribe.propTypes = {
  accessToken: PropTypes.string.isRequired
}
